import axios from '@/utils/axios'

export function getInternalConsumptions() {
    return axios.get('/internal-consumptions')
}

export function getInternalConsumption(id) {
    return axios.get(`/internal-consumptions/${id}`)
}

export function getInternalConsumptionDropdown() {
    return axios.get('/internal-consumptions/dropdown')
}

export function createInternalConsumption(data) {
    return axios.post('/internal-consumptions', data)
}

export function updateInternalConsumption(id, data) {
    return axios.put(`/internal-consumptions/${id}`, data)
}

export function deleteInternalConsumption(id) {
    return axios.delete(`/internal-consumptions/${id}`)
}

export function toggleInternalConsumptionStatus(id) {
    return axios.patch(`/internal-consumptions/${id}/status`)
}